import { Container, H1Summary } from "components/styled-components/generic";
import { Tooltip } from "components/styled-components/tooltip";
import {
  disclaimerChargeTime,
  disclaimerNewRange,
} from "constants/disclaimers";

export type CalculationResultProps = {
  batteryChargingTime: string | undefined;
  range: number | null | undefined;
  batteryLevel: number[];
};

export function CalculationResult(p: CalculationResultProps) {
  return (
    <Container>
      <H1Summary textAlign="center">
        Ladezeit:{" "}
        <span>
          {p.batteryChargingTime}
          <Tooltip id="charge-time" tip={disclaimerChargeTime} />
        </span>
        {p.range && (
          <div>
            Neue Reichweite:{" "}
            <span>
              {Math.floor(p.range * (p.batteryLevel[1] / 100))} km
              <Tooltip id="new-range" tip={disclaimerNewRange} />
            </span>
          </div>
        )}
      </H1Summary>
    </Container>
  );
}
